// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2kW1B","footer":"ModalInfo_footer__1JQ-N"};